import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getListRolesNameSA } from "../../api/MasterRole";
import {
  editSingleUserSA,
  getRoleNameProfileSA,
  getSearchListUsersSA,
} from "../../api/MasterUser";
import { IMsRole } from "../../interfaces/IMsRole";
import { IUserList } from "../../interfaces/IUserList";
import { UserRoleFormData } from "../../interfaces/UserRoleFormData";
import { selectUserProfile } from "../../store/auth/selector";
import { setUserRole } from "../../store/auth/slice";

interface Return {
  data: {
    loading: boolean;
    userList: IUserList[];
    listRolesName: IMsRole[];
  };
  method: {
    onGetUserList(search?: string): void;
    onGetListRolesName(): void;
    onEditUserRole(formData: UserRoleFormData): void;
    onSetCurrentUserRole(): void;
  };
}

export default function useViewModel(): Return {
  const [userList, setUserList] = useState<IUserList[]>([]);
  const [listRolesName, setListRolesName] = useState<IMsRole[]>([]);
  const [loading, setLoading] = useState(false);
  const profile = useSelector(selectUserProfile);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSetCurrentUserRole = useCallback(async () => {
    await getRoleNameProfileSA(profile.BinusianId)
      .then((res) => dispatch(setUserRole(res)))
      .then(() => {
        navigate("/");
        window.location.reload();
      })
      .catch((error) => console.log("Error fetching data:", error));
  }, [getRoleNameProfileSA]);

  const onGetUserList = useCallback(
    async (search?: string) => {
      setLoading(true);
      await getSearchListUsersSA(search)
        .then((res) => setUserList(res.map((e) => IUserList.fromJSON(e))))
        .then(() => {
          setLoading(false);
        })
        .catch((error) => console.log("Error fetching data:", error));
    },
    [getSearchListUsersSA]
  );

  const onGetListRolesName = useCallback(async () => {
    setLoading(true);
    await getListRolesNameSA()
      .then((res) => setListRolesName(res))
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
        setLoading(false);
      });
  }, [getListRolesNameSA]);

  const onEditUserRole = useCallback(
    async (formData: UserRoleFormData) => {
      setLoading(true);
      await editSingleUserSA(
        formData.binusianId,
        formData.roleName,
        profile.BinusianId
      )
        .then(() => {
          setLoading(false);
          if (formData.binusianId === profile.BinusianId) {
            onSetCurrentUserRole();
            return;
          }
          onGetUserList();
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          setLoading(false);
        });
    },
    [editSingleUserSA]
  );

  return {
    data: {
      loading,
      userList,
      listRolesName,
    },
    method: {
      onGetUserList,
      onGetListRolesName,
      onEditUserRole,
      onSetCurrentUserRole,
    },
  };
}
